module.exports = __webpack_public_path__ + "img/Weihnachtsmarkt.ea794bad.jpg";